import { Component, inject } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { IconComponent } from '../../icon/icon.component';
import { UserOderStatus } from '@models/orders.model';
import { AuthService } from '@services/auth.service';
import { PERMISSIONS } from '@models/users.model';
import { CartService } from '@services/cart.service';
import { OrdersService } from '@services/orders.service';
import { switchMap, map, catchError, of } from 'rxjs';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'market-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [RouterModule, IconComponent, AsyncPipe],
})
export class FooterComponent {
  private orderService = inject(OrdersService);
  private activatedRoute = inject(ActivatedRoute);

  iconAttr = { width: '24', height: '24', 'stroke-width': '1.5px' };

  role = inject(AuthService).userInfo().role;
  totalItem = inject(CartService).totalItem;

  count$ = this.activatedRoute.queryParamMap.pipe(
    switchMap(() => this.orderService.getOrderCount()),
    map(x => x.data),
    catchError(() =>
      of({
        pending: 0,
        approved: 0,
        completed: 0,
        canceled: 0,
      })
    )
  );

  get orderStatus() {
    return UserOderStatus;
  }

  get permission() {
    return PERMISSIONS;
  }
}
